import {MessageDescriptor} from 'react-intl';
import {ReactNode, useEffect, useRef} from 'react';

import {AssistantWidgetHeader} from '@stripe-internal/conversations-ui';

import {ActiveTopBar} from '../../support/components/ActiveTopBar';
import {HeaderActions} from './HeaderActions';
import {HeaderBadge} from './HeaderBadge';
import {sendMinimizedHeight} from '../../../core/lib/parentMessageBus/messages';
import {useApp, useVisibility} from '../../../core/hooks/appHooks';

type Props = {
  title?: MessageDescriptor;
  height?: number | string;
  badge?: ReactNode;
  headerActions?: ReactNode;
  subHeader?: ReactNode;
};

export function StripeAssistantWidgetHeader({
  title,
  height,
  badge,
  headerActions,
  subHeader,
}: Props) {
  const app = useApp();
  const ref = useRef<HTMLDivElement | null>(null);

  const {visibility, open, close, minimize} = useVisibility();

  useEffect(() => {
    if (ref.current) {
      sendMinimizedHeight(app.parentMessageBus, ref.current.offsetHeight);
    }
  }, [app.parentMessageBus]);

  return (
    <AssistantWidgetHeader
      ref={ref}
      height={height}
      title={title}
      badge={badge ?? <HeaderBadge />}
      headerActions={headerActions ?? <HeaderActions />}
      subHeader={subHeader ?? <ActiveTopBar />}
      visibility={visibility}
      onOpen={open}
      onMinimize={minimize}
      onClose={close}
    />
  );
}
